import type {
  WidgetElementsBookingElementButtonStyles,
  WidgetElementsBookingElementButtonStylesDto,
} from "@/elements/widget/elements/booking-element/button/styles/widget-elements-booking-element-button-styles";
import { sanitizeWidgetElementsBookingElementButtonStyles } from "@/elements/widget/elements/booking-element/button/styles/widget-elements-booking-element-button-styles.utilities";

export const mapWidgetElementsBookingElementButtonStylesFromDto = (
  widgetElementsBookingElementButtonDto: WidgetElementsBookingElementButtonStylesDto,
): WidgetElementsBookingElementButtonStyles =>
  sanitizeWidgetElementsBookingElementButtonStyles({
    fontSize: widgetElementsBookingElementButtonDto.fontSize,
    fontWeight: widgetElementsBookingElementButtonDto.fontWeight,
    border: widgetElementsBookingElementButtonDto.border,
    borderRadius: widgetElementsBookingElementButtonDto.borderRadius,
    width: widgetElementsBookingElementButtonDto.width ?? undefined,
    height: widgetElementsBookingElementButtonDto.height ?? undefined,
    padding: widgetElementsBookingElementButtonDto.padding,
  });
